import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { PCC_PDP_LUCID_TAX_DISCLAIMER } from '@app/constants/featureFlags';

const GstTableHeaderDisclaimer = ({ className = '', taxDisclaimerMessage }) => {
  const taxDisclaimerFeatureFlag = useSelector(
    s => s.featureFlag?.[PCC_PDP_LUCID_TAX_DISCLAIMER]
  );
  const includeGST = useSelector(s => s.dealerCustomer?.gstIncludesTax);
  const [t] = useTranslation();

  const GSTConditional = includeGST ? t('GST_INCLUDES') : t('GST_EXCLUDES');
  return (
    <small className={cx('text-xs text-transform-none', className)}>
      {taxDisclaimerFeatureFlag ? taxDisclaimerMessage : GSTConditional}
      <sup>&dagger;</sup>
    </small>
  );
};

GstTableHeaderDisclaimer.propTypes = {
  className: PropTypes.string,
  taxDisclaimerMessage: PropTypes.string
};

export default GstTableHeaderDisclaimer;
